import React, { useState } from 'react';
import ProjectInput from './inputs/ProjectInput';
import Table from '../../common/Table';
import { doc, deleteDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase/Firebase';

const Projects = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const orgId = localStorage.getItem('orgId');

  const projectHeaders = [
    { label: 'Job No.', key: 'job' },
    { label: 'Description', key: 'description' },
    { label: 'Status', key: 'status' },
    { label: 'Zip Code', key: 'zipCode' },
  ]

  const handleDelete = async (item) => {
    if (!item || !item.id) return;

    const projectRef = doc(db, 'Projects', item.id);

    try {
      await deleteDoc(projectRef);
      console.log(`Project with ID ${item.id} has been deleted.`);
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleSignOut = () => {
    auth?.signOut();
  };

  const DropdownMenu = () => {
    return (
      <div style={styles.menu}>
        <div style={styles.menuItem}>
          Plan: Free Tier
        </div>
        <div style={styles.menuItem}>
          Settings
        </div>
        <div style={styles.menuItem}>
          Resource Center
        </div>
        <div style={styles.menuItem} onClick={handleSignOut}>
          Sign Out
        </div>
      </div>
    );
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={styles.header}>
        <h2>Manage Projects</h2>
        <div style={styles.container} onClick={() => setDropdownVisible(!isDropdownVisible)}>
          <div style={styles.accountText}>Account</div>
          {isDropdownVisible && <DropdownMenu />}
        </div>
      </div>
      <ProjectInput orgId={orgId}/>
      <hr style={{ margin: '20px 0' }} />
      <Table orgId={orgId} headers={projectHeaders} collectionName="Projects" onDelete={handleDelete} />
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  container: {
    position: 'relative',
    cursor: 'pointer',
  },
  menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    minWidth: '150px',
    zIndex: 1000,
  },
  menuItem: {
    padding: '10px',
    borderBottom: '1px solid #ddd',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '14px',
  },
  accountText: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
}

export default Projects;

